<template>
  <div class="content">
    <div class="top">
      <div class="elec_speed">
        <el-steps :active="2" finish-status="success" simple>
          <el-step :title=ApplicationSelection></el-step>
          <el-step :title=AppLoadconditions></el-step>
          <el-step :title=ReducerLoadconditions></el-step>
          <el-step :title=reducerSize></el-step>
          <el-step :title=selectMotor></el-step>
          <el-step :title=complete></el-step>
        </el-steps>
      </div>
    </div>
    <!-- 减速机系列详情表 -->
    <div class="elec_detail">
      <el-row>
        <el-col :span="24">
          <h3>{{$t('message.info06')}}</h3>
          <div class="cascader_box">
            <span style="padding-right:10px;">{{$t('message.title10')}}</span>
            <el-cascader
              :options="options_2"
              :show-all-levels="false"
              v-model="selectedOptions_2"
              :props="optionProps_2"
              @click.native="_getreducerlist()"
              @change="handleChange_2"
            >
            </el-cascader>
          </div>
        </el-col>
        <el-col :span="24">
          <h3>{{$t('message.info01')}}</h3>
          <div class="cascader_box">
            <span style="padding-right:10px;">{{$t('message.title11')}}</span>
            <el-cascader
              :options="options"
              :show-all-levels="false"
              v-model="selectedOptions"
              :props="optionProps"
              @click.native="_getratiolist()"
              @change="handleChange"
            >
            </el-cascader>
          </div>
        </el-col>
        <el-col :span="24">
          <h3>{{$t('message.info02')}}</h3>
          <div class="slider_box">
            <el-slider
              v-model="value"
              :step="1"
              :max="18"
              :min="4"
              @change="sliderChange"
              show-input
              disabled>
            </el-slider>
          </div>
        </el-col>
        <el-col :span="24">
          <h3>{{$t('message.info03')}}</h3>
          <el-col :span="24" class="paramBox">
            <el-col :span="8">
              <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px" class="dynamic">
                <span class="dynamic_text">{{$t('message.title01')}}</span>
                <el-form-item
                  v-for="(domain, index) in dynamicValidateForm.domains"
                  :label="'T'  + (index+1)"
                  :key="domain.key"
                  :prop="'domains.' + index + '.value'"
                  :rules="[{
                    required: true, message: '此项不能为空', trigger: 'blur'
                  }]">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="domain.value" auto-complete="off" :disabled="true"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form :model="dynamicValidateForm_2" ref="dynamicValidateForm_2" label-width="100px" class="dynamic">
                <span class="dynamic_text">{{$t('message.title02')}}</span>
                <el-form-item
                  v-for="(domain, index) in dynamicValidateForm_2.domains"
                  :label="'n' + (index+1)"
                  :key="domain.key"
                  :prop="'domains.' + index + '.value'"
                  :rules="[{
                    required: true, message: '此项不能为空', trigger: 'blur'
                  }]">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="domain.value" auto-complete="off" :disabled="true"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form :model="dynamicValidateForm_3" ref="dynamicValidateForm_3" label-width="100px" class="dynamic">
                <span class="dynamic_text">{{$t('message.title03')}}</span>
                <el-form-item
                  v-for="(domain, index) in dynamicValidateForm_3.domains"
                  :label="'t' + (index+1)"
                  :key="domain.key"
                  :prop="'domains.' + index + '.value'"
                  :rules="[{
                    required: true, message: '此项不能为空', trigger: 'blur'
                  }]">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="domain.value" auto-complete="off" :disabled="true"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form :model="dynamicValidateForm_4" ref="dynamicValidateForm_4" label-width="100px" class="dynamic">
                <span class="dynamic_text">{{$t('message.title04')}}</span>
                <el-form-item
                  v-for="(domain, index) in dynamicValidateForm_4.domains"
                  :label="'Fr' + (index+1)"
                  :key="domain.key"
                  :prop="'domains.' + index + '.value'"
                  :rules="[{
                    required: true, message: '此项不能为空', trigger: 'blur'
                  }]">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="domain.value" auto-complete="off" :disabled="true"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form :model="dynamicValidateForm_5" ref="dynamicValidateForm_5" label-width="100px" class="dynamic">
                <span class="dynamic_text">{{$t('message.title05')}}</span>
                <el-form-item
                  v-for="(domain, index) in dynamicValidateForm_5.domains"
                  :label="'Ft' + (index+1)"
                  :key="domain.key"
                  :prop="'domains.' + index + '.value'"
                  :rules="[{
                    required: true, message: '此项不能为空', trigger: 'blur'
                  }]">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="domain.value" auto-complete="off" :disabled="true"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form :model="form_1" ref="form_1" :rules="rules_1" label-width="100px" class="dynamic">
                <span class="dynamic_text">{{$t('message.title06')}}</span>
                <el-form-item prop="Lr" label="Lr">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form_1.Lr" auto-complete="off"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form :model="form_2" ref="form_2" :rules="rules_2" label-width="100px" class="dynamic">
                <span class="dynamic_text">{{$t('message.title07')}}</span>
                <el-form-item prop="Lt" label="Lt">
                  <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form_2.Lt" auto-complete="off"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-col>
        </el-col>
        <el-col :span="24">
          <h3>{{$t('message.info04')}}</h3>
          <div class="slider_box" style="margin-left:100px;">
            <el-form ref="form_KA" :model="form_KA" style="margin-bottom:20px;">
              <el-radio-group v-model="form_KA.resource">
                <el-radio label="1.0" border>1.0</el-radio>
                <el-radio label="1.1" border>1.1</el-radio>
                <el-radio label="1.3" border>1.3</el-radio>
                <el-radio label="1.5" border>1.5</el-radio>
                <el-radio label="1.8" border>1.8</el-radio>
              </el-radio-group>
            </el-form>
            <el-table :data="tableData" border style="width:67%;">
              <el-table-column prop="ka" label="KA" align='center'></el-table-column>
              <el-table-column prop="peiriod" :label=CycleNumberHour align='center'></el-table-column>
            </el-table>
          </div>
        </el-col>
        <!-- <el-col :span="24">
          <h3>技术图纸</h3>
          <el-carousel :interval="4000" type="card" height="300px">
            <el-carousel-item v-for="item in 6" :key="item">
              <h3>{{ item }}</h3>
            </el-carousel-item>
          </el-carousel>
        </el-col> -->
        <el-col :span="24" style="padding-bottom:50px;padding-top:50px;">
          <div style="width:30%;margin:0 auto;">
            <span class="button" @click="returnPrePage">{{$t('message.Return')}}</span>
            <span class="button" @click="toNextPage">{{$t('message.Next')}}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 右侧悬浮框 -->
    <div class="rightPicBox">
      <img :src=rightPicUrl alt="">
    </div>
  </div>
</template>
<script>
  import {
    getServicelife
  }from '@/store/electric_app'
  import {
    getreducerlist,
    getratiolistt
  } from '@/store/electric_motor'
  export default {
    name: 'SelectedLoad',
    data() {
      return {
        rightPicUrl:'',
        tabPosition: 'left',
        form: {},
        value:0,
        reducerName:'',
        options:[],
        selectedOptions:[],
        optionProps: {
          value: 'reduction_ratio',
          label: 'label',
        },
        options_2:[],
        selectedOptions_2:[],
        optionProps_2: {
          value: 'reducer_series_name',
          label: 'label',
        },
        radio: '1',
        dynamicValidateForm: {
          domains: [{
            value: ''
          }]
        },
        dynamicValidateForm_2: {
          domains: [{
            value: ''
          }]
        },
        dynamicValidateForm_3: {
          domains: [{
            value: ''
          }]
        },
        dynamicValidateForm_4: {
          domains: [{
            value: ''
          }]
        },
        dynamicValidateForm_5: {
          domains: [{
            value: ''
          }]
        },
        form_1:{
          Lr:''
        },
        rules_1:{
          Lr:[
            {required: true, message:'此项不能为空'}
          ]
        },
        form_2:{
          Lt:''
        },
        rules_2:{
          Lt:[
            {required: true, message:'此项不能为空'}
          ]
        },
        sliderChangeValue:'',
        selectLoadParam:{},
        form_KA:{
          resource:''
        },
        ElectricMachine_2:{},
        Param:{},
        ApplicationSelection:this.$t('message.ApplicationSelection'),
        AppLoadconditions:this.$t('message.AppLoadconditions'),
        ReducerLoadconditions:this.$t('message.ReducerLoadconditions'),
        reducerSize:this.$t('message.reducerSize'),
        selectMotor:this.$t('message.selectMotor'),
        complete:this.$t('message.complete'),
        loadCondition:this.$t('message.loadCondition'),
        Operationmode:this.$t('message.Operationmode'),
        CycleNumberHour: this.$t('message.CycleNumberHour'),
        tableData: [{
          ka: '1.0',
          peiriod: '0-1000',
        },{
          ka: '1.1',
          peiriod: '1000-1500',
        },{
          ka: '1.3',
          peiriod: '1500-2000',
        },{
          ka: '1.5',
          peiriod: '2000-3000',
        },{
          ka: '1.8',
          peiriod: '3000-5000',
        }]
      }
    },
    props:{
      paramLoad:Object,
      required:true
    },
    mounted(){
      for(var i=0;i < 3;i++){
        this.dynamicValidateForm.domains.push({
          value: '',
          key: Date.now()
        });
        this.dynamicValidateForm_2.domains.push({
          value: '',
          key: Date.now()
        });
        this.dynamicValidateForm_3.domains.push({
          value: '',
          key: Date.now()
        });
        this.dynamicValidateForm_4.domains.push({
          value: '',
          key: Date.now()
        });
        this.dynamicValidateForm_5.domains.push({
          value: '',
          key: Date.now()
        });
      }
      this.form_1.Lr = '0'
      this.form_2.Lt = '0'
      var lang = localStorage.getItem('lang')
      if(lang == 'en'){
        this.rightPicUrl = '../../../static/load_en.png';
      }else{
        this.rightPicUrl = '../../../static/load_cn.png';
      }
    },
    methods: {
      toNextPage:function(){
        // 配置参数 构造数据
        this.Param.fw = this.form_KA.resource
        this.Param.Lr = this.form_1.Lr
        this.Param.Lt = this.form_2.Lt
        this.Param.N = 4
        this.Param.reducer_series_name = this.ElectricMachine_2.motor_reducer
        this.Param.i = this.ElectricMachine_2.motor_ratio

        this.Param.T1 = this.dynamicValidateForm.domains[0].value
        this.Param.T2 = this.dynamicValidateForm.domains[1].value
        this.Param.T3 = this.dynamicValidateForm.domains[2].value
        this.Param.T4 = this.dynamicValidateForm.domains[3].value

        this.Param.n1 = this.dynamicValidateForm_2.domains[0].value
        this.Param.n2 = this.dynamicValidateForm_2.domains[1].value
        this.Param.n3 = this.dynamicValidateForm_2.domains[2].value
        this.Param.n4 = this.dynamicValidateForm_2.domains[3].value

        this.Param.t1 = this.dynamicValidateForm_3.domains[0].value
        this.Param.t2 = this.dynamicValidateForm_3.domains[1].value
        this.Param.t3 = this.dynamicValidateForm_3.domains[2].value
        this.Param.t4 = this.dynamicValidateForm_3.domains[3].value

        this.Param.Fr1 = this.dynamicValidateForm_4.domains[0].value
        this.Param.Fr2 = this.dynamicValidateForm_4.domains[1].value
        this.Param.Fr3 = this.dynamicValidateForm_4.domains[2].value
        this.Param.Fr4 = this.dynamicValidateForm_4.domains[3].value

        this.Param.Ft1 = this.dynamicValidateForm_5.domains[0].value
        this.Param.Ft2 = this.dynamicValidateForm_5.domains[1].value
        this.Param.Ft3 = this.dynamicValidateForm_5.domains[2].value
        this.Param.Ft4 = this.dynamicValidateForm_5.domains[3].value
        sessionStorage.setItem('i',this.Param.i);
        getServicelife(this.Param).then((response)=>{
          if(response.success === true){
            const data = response.data
            this.$emit("listenParam_2",data);
            this.$emit("listenParam_3",this.Param.reducer_series_name);
            this.$emit("listenPageChange","to_ReducerSizePage");
          }else{
            this.$message({
              message: '字段填写有误!',
              type: 'warning'
            });
          }
        })
      },
      returnPrePage:function(){
        var childPageName = sessionStorage.getItem('childPageName');
        console.log(childPageName)
        this.$emit("listenPageChange",childPageName);
      },
      // 获取减速机列表
      _getreducerlist() {
        getreducerlist().then((response) => {
          if (response.success === true) {
            this.options_2 = [];
            this.options_2 = response.data;
          }
        })
      },
      // 获取减速比列表
      _getratiolist() {
        const param = this.ElectricMachine_2.motor_reducer;
        if(param) {
          getratiolistt(param).then((response) => {
            if (response.success === true) {
              this.options = [];
              this.options = response.data;
              console.log(this.options_2)
            }
          })
        }
      },
      handleChange_2(val) {
        this.selectLoadParam.i = val[0];
        this.ElectricMachine_2.motor_reducer = val[0];

        this.options = [];
        this.ElectricMachine_2.motor_ratio = '';
      },
      handleChange(val) {
        this.ElectricMachine_2.motor_ratio = val[0];
      },
      sliderChange(val) {
        this.selectLoadParam.N = val;
        for(var i=0;i < 18;i++){
          this.dynamicValidateForm.domains.splice(i, 18);
          this.dynamicValidateForm_2.domains.splice(i, 18);
          this.dynamicValidateForm_3.domains.splice(i, 18);
          this.dynamicValidateForm_4.domains.splice(i, 18);
          this.dynamicValidateForm_5.domains.splice(i, 18);
        }
        const step = val;
        for(var i=0;i < step;i++){
          this.dynamicValidateForm.domains.push({
            value: '',
            key: Date.now()
          });
          this.dynamicValidateForm_2.domains.push({
            value: '',
            key: Date.now()
          });
          this.dynamicValidateForm_3.domains.push({
            value: '',
            key: Date.now()
          });
          this.dynamicValidateForm_4.domains.push({
            value: '',
            key: Date.now()
          });
          this.dynamicValidateForm_5.domains.push({
            value: '',
            key: Date.now()
          });
        }
        this.sliderChangeValue = val;
      },
      // 给负载条件赋值
      loadConditionalAssignment:function(data){
        console.log(data);
        this.dynamicValidateForm.domains[0].value = data.T1;
        this.dynamicValidateForm.domains[1].value = data.T2;
        this.dynamicValidateForm.domains[2].value = data.T3;
        this.dynamicValidateForm.domains[3].value = data.T4;

        this.dynamicValidateForm_2.domains[0].value = data.n1;
        this.dynamicValidateForm_2.domains[1].value = data.n2;
        this.dynamicValidateForm_2.domains[2].value = data.n3;
        this.dynamicValidateForm_2.domains[3].value = data.n4;

        this.dynamicValidateForm_3.domains[0].value = data.t1;
        this.dynamicValidateForm_3.domains[1].value = data.t2;
        this.dynamicValidateForm_3.domains[2].value = data.t3;
        this.dynamicValidateForm_3.domains[3].value = data.t4;

        this.dynamicValidateForm_4.domains[0].value = data.Fr1;
        this.dynamicValidateForm_4.domains[1].value = data.Fr2;
        this.dynamicValidateForm_4.domains[2].value = data.Fr3;
        this.dynamicValidateForm_4.domains[3].value = data.Fr4;

        this.dynamicValidateForm_5.domains[0].value = data.Ft1;
        this.dynamicValidateForm_5.domains[1].value = data.Ft2;
        this.dynamicValidateForm_5.domains[2].value = data.Ft3;
        this.dynamicValidateForm_5.domains[3].value = data.Ft4;
      }
    }
  };
</script>
<style scoped>
  .rightPicBox {
    width:250px;
    height:1000px;
    position: absolute;
    right: 80px;
    top: 180px;
    border-radius: 15px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
  }
  .content {
    width:100%;
    height: 100%;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
    position: relative;
  }
  .top {
    height:100px;
    border-bottom:1px solid #EBEBEB;
  }
  .elec_speed {
    width:80%;
    margin:0 auto;
    padding-top:25px;
  }
  .el-steps {
    border-radius: 10px;
    background-color: #F5F7FA;
    background:url('../../../static/step.png') no-repeat #F5F7FA;
    background-size:17% 100%;
    background-position-x:44%;
  }
  .elec_select_left img{
    width: 268px;
    height: 268px;
    display: block;
    margin: 0 auto;
    padding-top: 100px;
  }
  .elec_select_left .text{
    text-align: center;
    font-weight: bold;
    font-size: 20px;
  }
  .el-cascader-menus el-popper{
    z-index: 2010;
    position: absolute;
    top: 284px;
    left: 952px;
  }
  .select_box {
    padding-left:10px;
    padding-top:130px;
  }
  .toNextPage {
    width:97px;
    height:42px;
    border-radius: 5px;
    background: #142479;
    text-align: center;
    line-height: 42px;
    color:white;
    margin-top:40px;
    cursor: pointer;
  }
  .elec_detail {
    width:80%;
    margin-top:70px;
    margin-left:40px;
  }
  .elec_detail h3 {
    padding-left:50px;
  }
  .slider_box {
    width:70%;
    margin:0 auto;
    padding-top:20px;
    padding-bottom:20px;
  }
  .cascader_box {
    width:85%;
    margin:0 auto;
    padding-top:20px;
    padding-bottom:20px;
    padding-left:30px;
  }
  .form_box {
    width:90%;
    margin:0 auto;
  }
  .form_box_title {
    width:90%;
    margin:0 auto;
  }
  .form_box .form_box_value .el-col , .form_box .form_box_title .el-col {
    padding-top:10px;
  }

  .el-carousel {
    width:80%;
    margin: 0 auto;
    margin-top:30px;
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .button {
    display: inline-block;
    width:97px;
    height:42px;
    border-radius: 10px;
    background:#142479;
    color:#C6C6C6;
    text-align: center;
    line-height: 42px;
    margin-left:15px;
    cursor: pointer;
    font-size: 14px;
  }
  .dynamic{
    width:90%;
  }
  .dynamic_text{
    padding-left:100px;
    line-height:50px;
  }
  .paramBox {
    width:90%;
  }
  /* 1366px下样式 */
  @media screen and (max-width: 1367px) {
    .rightPicBox {
      width:200px;
      height:1000px;
      position: absolute;
      right: 30px;
      top: 160px;
      border-radius: 15px;
      box-shadow: 0 0 15px rgb(224, 224, 224);
    }
    .elec_detail {
      width:80%;
      margin-top:70px;
      margin-left:20px;
    }
    .paramBox {
      width:93%;
    }
    .cascader_box {
      width:85%;
      margin:0 auto;
      padding-top:20px;
      padding-bottom:20px;
      padding-left:85px;
    }
    .content {
      width:100%;
      height: 100%;
      background: white;
      border-radius: 5px;
      box-shadow: 0 0 15px rgb(224, 224, 224);
    }
    @media screen and (-webkit-min-device-pixel-ratio:0){
      .content {
        width:100%;
        height: 100%;
        background: white;
        border-radius: 5px;
        box-shadow: 0 0 15px rgb(224, 224, 224);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ApplicationSelection/SelectedReducerLoad.vue